import { LANGUAGE } from "@/common/utils/constants.js";

export const ABOUT_THE_CLIENT_PPT = {
	[LANGUAGE.en.short]: {
		title: `About The Client`,
		confidential: `<i><b>For internal purposes only.</b> Please do not share, client information outside of the organization.</i>`,
		companyConfidential: 'Client’s name is confidential'
	},
	[LANGUAGE.de.short]: {
		title: `Über den Kunden`,
		confidential: `<i><b>Nur für interne Zwecke.</b> Bitte geben Sie keine Kundeninformationen außerhalb der Organisation weiter.</i>`,
		companyConfidential: 'Der Name des Kunden ist vertraulich'
	},
	[LANGUAGE.fr.short]: {
		title: `À propos du client`,
		confidential: `<i><b>À des fins internes seulement.</b> Veuillez ne pas partager les renseignements sur les clients à l’extérieur de l’organisation.</i>`,
		companyConfidential: 'Le nom du client est confidentiel'
	},
	[LANGUAGE.it.short]: {
		title: `Informazioni sul cliente`,
		confidential: `<i><b>Solo per scopi interni.</b> Si prega di non condividere le informazioni sui clienti al di fuori dell\`organizzazione.</i>`,
		companyConfidential: 'Il nome del cliente è riservato'
	},
	[LANGUAGE.ja.short]: {
		title: `クライアントについて`,
		confidential: `<i><b>内部目的のみ。</b> クライアント情報を組織外と共有しないでください。</i>`,
		companyConfidential: 'クライアントの名前は秘密です'
	},
	[LANGUAGE.es.short]: {
		title: `Acerca del Cliente`,
		confidential: `<i><b>Solo para fines internos.</b> No comparta la información del cliente fuera de la organización.</i>`,
		companyConfidential: 'El nombre del cliente es confidencial'
	},
}
